import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router'
import Popup from '../../ReusableFunctions/Popup';
import { getAdminPostDetails } from '../../apis/adminAPIs/Feeds';
import Loading from '../../ReusableFunctions/Loader';
import dateFormat from 'dateformat';

export default function ViewPost() {
    const {post}=useLocation().state || null;
    const [postDetails, setPostDetails] = useState({})
    const [postDescriptions, setpostDescriptions] = useState(null)
    const [loading, setLoading] = useState(false);

  const getPostDetailsFunc=async(id)=>{
    try{
      setLoading(true)
      Loading.set(true);
     let details= await getAdminPostDetails(id);    
     setPostDetails(details);
     if(details){
        let otherLanguages = Object.entries(details?.texts);
        setpostDescriptions(otherLanguages);
     }
     setLoading(false);
     Loading.set(false);
    }catch(err){
        console.log("error",err);
        Loading.set(false);
        console.error('Error getting post details',err)
        Popup.alert("ERROR","something went wrong while getting post details","ERROR");
    }
  }

   useEffect(()=>{
     getPostDetailsFunc(post?.id);
   },[post?.id])
  return (
    <div className="max-w-full  px-14 py-8">
    <h1 className="text-2xl font-bold mb-4">Post Details </h1>
    
      <div className='flex w-full gap-4  '>
        <div className='flex flex-col w-[25%] gap-5 '>
          <div>
          </div>
            <div className="-mt-[18px]">
              <img src={post?.image_url || "/placeholder.svg"} alt="Preview" className="max-w-full h-[300px] rounded-lg shadow-md" />
            </div>
            <div className='w-full flex justify-between' >
             <div className='flex gap-1 items-center'>
                <p className='text-sm font-semibold'>Likes :</p>
                <span className='text-sm font-normal'>{post.likes}</span>
             </div>
             <div className='flex gap-1 items-center'>
                <span className='text-sm font-normal'>{dateFormat(post?.post_date, "dd mmm yyyy")}</span>
             </div>
            </div>
        </div>
        <div className='w-[75%] max-h-[800px] overflow-auto ' >
        <div className='grid grid-cols-2 md:grid-cols-2 custom-lg:grid-cols-3  gap-y-8 gap-x-8'>
        {postDescriptions?.map(([lang, content]) => (
                    <div key={lang} className="p-4 border rounded-lg shadow-md bg-white">
                        <h2 className="text-[18px] font-semibold">{lang}</h2>
                        <h3 className="text-[16px] mt-2 leading-[1.2rem] max-h-[300px] font-medium">{content.title}</h3>
                        <div className=' max-h-[400px] overflow-auto'>
                        <p className="text-gray-600 text-[14px] mt-2">{content.text}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
        
      </div>
  </div>
  )
}
